import { ca } from '@cian/analytics';

import { TCallbackOpener } from '../../types/callbackPopup';

interface IUser {
  userId?: number;
  extra?: {
    [ket: string]: string | number | boolean;
  };
}

interface ITrackCallbackSendSimilarParams {
  label: string;
  offerId: number;
  position: number;
  placeType: TCallbackOpener;
  user: IUser;
}

export function trackCallbackSimilarSend({
  label,
  offerId,
  position,
  placeType,
  user,
}: ITrackCallbackSendSimilarParams) {
  ca('eventSite', {
    action: `CallBack_popup_send_${placeType}`,
    category: 'Card',
    label,
    name: 'oldevent',
    products: [
      {
        extra: { is_similar: true },
        id: offerId,
        offerType: 'offer',
        position,
      },
    ],
    user,
  });
}
